"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OpenSansHebRegular = exports.OpenSansHebLight = exports.OpenSansHebBold = exports.OpenSansHebBlack = void 0;
var _opensanshebrewExtrabold = _interopRequireDefault(require("../assets/fonts/openSansHebrew/opensanshebrew-extrabold.woff2"));
var _opensanshebrewExtrabold2 = _interopRequireDefault(require("../assets/fonts/openSansHebrew/opensanshebrew-extrabold.woff"));
var _opensanshebrewBold = _interopRequireDefault(require("../assets/fonts/openSansHebrew/opensanshebrew-bold.woff2"));
var _opensanshebrewBold2 = _interopRequireDefault(require("../assets/fonts/openSansHebrew/opensanshebrew-bold.woff"));
var _opensanshebrewRegular = _interopRequireDefault(require("../assets/fonts/openSansHebrew/opensanshebrew-regular.woff2"));
var _opensanshebrewRegular2 = _interopRequireDefault(require("../assets/fonts/openSansHebrew/opensanshebrew-regular.woff"));
var _opensanshebrewLight = _interopRequireDefault(require("../assets/fonts/openSansHebrew/opensanshebrew-light.woff2"));
var _opensanshebrewLight2 = _interopRequireDefault(require("../assets/fonts/openSansHebrew/opensanshebrew-light.woff"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var OpenSansHebLight = exports.OpenSansHebLight = {
  fontDisplay: 'swap',
  fontFamily: 'Open-sans-hebrew',
  fontStyle: 'normal',
  fontWeight: 300,
  src: "\n    url(".concat(_opensanshebrewLight.default, ") format('woff2'),\n    url(").concat(_opensanshebrewLight2.default, ") format('woff');\n  ")
};
var OpenSansHebRegular = exports.OpenSansHebRegular = {
  fontDisplay: 'swap',
  fontFamily: 'Open-sans-hebrew',
  fontStyle: 'normal',
  fontWeight: 400,
  src: "\n    url(".concat(_opensanshebrewRegular.default, ") format('woff2'),\n    url(").concat(_opensanshebrewRegular2.default, ") format('woff');\n  ")
};
var OpenSansHebBold = exports.OpenSansHebBold = {
  fontDisplay: 'swap',
  fontFamily: 'Open-sans-hebrew',
  fontStyle: 'normal',
  fontWeight: 700,
  src: "\n    url(".concat(_opensanshebrewBold.default, ") format('woff2'),\n    url(").concat(_opensanshebrewBold2.default, ") format('woff');\n  ")
};
var OpenSansHebBlack = exports.OpenSansHebBlack = {
  fontDisplay: 'swap',
  fontFamily: 'Open-sans-hebrew',
  fontStyle: 'normal',
  fontWeight: 900,
  src: "\n    url(".concat(_opensanshebrewExtrabold.default, ") format('woff2'),\n    url(").concat(_opensanshebrewExtrabold2.default, ") format('woff');\n  ")
};